import { SurveyKind, SurveyQuestion, SurveyType } from '../../features/survey/surveyApi'

// Үлгі сұрақтар: опрос түрін таңдағанда редакторға қойылады. Это содержимое опроса (сразу KZ и RU), не тексты интерфейса.
const T: Record<SurveyType, [SurveyKind, string, string][]> = {
    MENTOR: [
        ['RATING', 'Кураторыңызбен қарым-қатынасыңызды бағалаңыз', 'Оцените ваше взаимодействие с куратором'],
        ['RATING', 'Кураторыңыздың жұмыс уақытында жауап беру жылдамдығын бағалаңыз', 'Оцените скорость ответа куратора в рабочее время'],
        ['RATING', 'Кураторыңыздың тапсырмаларды тексеру шынайылығын бағалаңыз', 'Оцените объективность проверки заданий куратором'],
        ['RATING', 'Кураторыңыздың сабақ бойынша көмектесу сапасын бағалаңыз', 'Оцените качество помощи куратора по урокам'],
        ['TEXT', 'Кураторыңызға айтар ұсынысыңыз/шағымыңыз (анонимді)', 'Ваши предложения/жалобы куратору (анонимно)'],
        ['TEXT', 'Курс жайлы ұсыныс немесе шағым (анонимді)', 'Предложения или жалобы по курсу (анонимно)'],
    ],
    SUBJECT_HEAD: [
        ['RATING', 'Пән басшысымен жұмыс істеу ыңғайлылығын бағалаңыз', 'Оцените удобство работы с руководителем предмета'],
        ['RATING', 'Тапсырмалар мен нұсқаулықтардың түсініктілігін бағалаңыз', 'Оцените понятность заданий и инструкций'],
        ['RATING', 'Сұрақтарыңызға жауап беру жылдамдығын бағалаңыз', 'Оцените скорость ответа на ваши вопросы'],
        ['RATING', 'Жұмысыңызды әділ бағалауын (KPI, жалақы) бағалаңыз', 'Оцените справедливость оценки вашей работы (KPI, зарплата)'],
        ['TEXT', 'Пән басшысына ұсыныс/шағым (анонимді)', 'Предложения/жалобы руководителю предмета (анонимно)'],
    ],
    TEACHER: [
        ['RATING', 'Мұғалім тақырыпты түсінікті түсіндіре ме?', 'Понятно ли учитель объясняет тему?'],
        ['RATING', 'Сабақтың сапасын бағалаңыз', 'Оцените качество урока'],
        ['RATING', 'Мұғалім сұрақтарыңызға жауап бере ме?', 'Отвечает ли учитель на ваши вопросы?'],
        ['RATING', 'Сабақтағы есептердің ҰБТ-ға пайдасын бағалаңыз', 'Оцените пользу задач на уроке для ЕНТ'],
        ['TEXT', 'Мұғалімге ұсыныс/шағым (анонимді)', 'Предложения/жалобы учителю (анонимно)'],
    ],
    NPS: [
        ['NPS', '0-ден 10-ға дейін: DostyqOnline-ды досыңызға ұсынар ма едіңіз?', 'От 0 до 10: порекомендовали бы вы DostyqOnline другу?'],
        ['TEXT', 'Неге осындай баға қойдыңыз?', 'Почему вы поставили такую оценку?'],
    ],
}

export const templateQuestions = (type: SurveyType): SurveyQuestion[] =>
    T[type].map(([kind, textKz, textRu]) => ({ kind, textKz, textRu, required: true, options: [] }))

// даты yyyy-MM-dd по Алматы, как считает бэкенд
export const todayAlmaty = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Asia/Almaty' })

const shift = (d: string, days: number, months = 0) => {
    const [y, m, day] = d.split('-').map(Number)
    const x = new Date(Date.UTC(y, m - 1 + months, day + days))
    return x.toISOString().slice(0, 10)
}
export const addDays = (d: string, n: number) => shift(d, n)
export const addMonths = (d: string, n: number) => shift(d, 0, n)

export const ddmm = (d: string | null) => (d ? d.split('-').reverse().slice(0, 2).join('.') : '-')
